<div>
    <div>
        <button type="button" class="btn btn-primary flex" (click)="addEditProject()">
            <icon-plus class="h-5 w-5 ltr:mr-3 rtl:ml-3" />
            Add Project
        </button>
    </div>

    <!-- project list -->
    <div class="relative pt-5">
        <div class="-mx-2 h-full">
            <div class="flex flex-nowrap items-start gap-5 overflow-x-auto px-2 pb-2">
                <ng-container *ngFor="let project of projectList" key="project.id">
                    <div class="panel w-80 flex-none">
                        <div class="mb-5 flex justify-between">
                            <h4 class="text-base font-semibold">{{ project.title }}</h4>

                            <div class="flex items-center">
                                <button type="button" class="hover:text-primary ltr:mr-2 rtl:ml-2" (click)="addEditTask(project.id)">
                                    <icon-plus-circle />
                                </button>
                                <div hlMenu class="dropdown">
                                    <button type="button" hlMenuButton class="hover:text-primary">
                                        <icon-horizontal-dots class="opacity-70 hover:opacity-100" />
                                    </button>
                                    <ul *hlMenuItems @toggleAnimation class="ltr:right-0 rtl:left-0">
                                        <li>
                                            <a href="javascript:;" *hlMenuItem="let menuItem" (click)="addEditProject(project)">Edit</a>
                                        </li>
                                        <li><a href="javascript:;" *hlMenuItem="let menuItem" (click)="deleteProject(project)">Delete</a></li>
                                        <li><a href="javascript:;" *hlMenuItem="let menuItem" (click)="clearProjects(project)">Clear All</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- task list -->
                        <div
                                [sortablejs]="project.tasks"
                                [sortablejsOptions]="{ animation: 200, group: 'default', ghostClass: 'sortable-ghost', dragClass:'sortable-drag' }"
                                class="connect-sorting-content min-h-[150px]"
                        >
                            <div class="sortable-list" *ngFor="let task of project.tasks" key="project.id + '' + task.id">
                                <div class="ticket mb-5 cursor-move space-y-3 rounded-md bg-white p-3 pb-5 shadow ">
                                    <ng-container *ngIf="task.image">
                                        <img src="https://scontent-lga3-2.xx.fbcdn.net/v/t39.30808-6/327435626_543715154380375_1008417951993836604_n.png?_nc_cat=109&ccb=1-7&_nc_sid=5f2048&_nc_ohc=SEeCy1N8Za0AX9kxqfK&_nc_ht=scontent-lga3-2.xx&oh=00_AfAcoojQcKfN-uMYkMqGSOXmHkVHK0FZOiRTzcOycFfETw&oe=66050FF6" alt="images" class="h-32 w-full rounded-md object-cover" />
                                    </ng-container>
                                    <div class="text-base font-medium">{{ task.title }}</div>
                                    <p class="break-all">{{ task.description }}</p>
                                    <div class="flex flex-wrap items-center gap-2">
                                        <ng-container *ngIf="task.tags?.length; else elseBlock">
                                            <ng-container *ngFor="let tag of task.tags; index as i" key="i">
                                                <div class="btn btn-outline-info flex px-2 py-1">
                                                    <icon-tag class="shrink-0" />

                                                    <span class="ltr:ml-2 rtl:mr-2">{{ tag }}</span>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <ng-template #elseBlock>
                                            <div class="btn flex px-2 py-1 text-white-dark shadow-none ">
                                                <icon-tag class="shrink-0" />
                                                <span class="ltr:ml-2 rtl:mr-2">No Tags</span>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="flex items-center justify-between">
                                        <div class="flex items-center font-medium hover:text-primary">
                                            <icon-calendar class="shrink-0 ltr:mr-3 rtl:ml-3" />
                                            <span>{{ task.date }}</span>
                                        </div>
                                        <div class="flex items-center">
                                            <button type="button" class="hover:text-info" (click)="addEditTask(project.id, task)">
                                                <icon-edit class="ltr:mr-3 rtl:ml-3" />
                                            </button>
                                            <button type="button" class="hover:text-danger" (click)="deleteConfirmModal(project.id, task)">
                                                <icon-trash-lines />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pt-3">
                            <button type="button" class="btn btn-primary mx-auto" (click)="addEditTask(project.id)">
                                <icon-plus />
                                Add Task
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- add project modal -->

</div>
